//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex'

import UAParser from 'ua-parser-js'

import {
    GET_USER_PARAMS,
    GET_MERGED_CONTACT_BY_ID,
    GET_RADIO_SETTINGS,
    RADIO_IS_TURN_ON,
    GET_IS_ELECTRON,
    GET_CLIENT_VERSION,
    GET_SID,
    GET_ROSCHAT_REDIRECTED_SERVER,
    GET_UID, GET_LOGIN,
    GET_SERVER_API,
} from '../../../store/gettersTypes'
import {
    ACT_INFO_PUSH,
    CALLS_CONTROLLER,
    ACT_RADIO_STATE_TOGGLE,
    ACT_RC_RADIO_CONNECT,
    ACT_SELECT_CONTACT,
} from '../../../store/actionsTypes'

import {
    USERDATA,
    CONTACTS,
    INFO,
    PHONE_CNTL,
    RADIO,
    RC_RADIO,
    CLIENTDATA,
    LOGIN,
} from '../../../store/modulesNames'

import MainContentContainer from "./MainContentContainer.vue"
import ListItem from "../../custom/ListItem.vue"
import TechnicalJournals from "../../settings/TechnicalJournal.vue"
import Logger from '../../../common/Logger'

import {PHONE_CONTACT_FIELD_TYPE, SUPPORT_GROUP_CID} from '../../../constants'

import { getIsFullCompactMode, setSideVisible } from '../../../../ext/trackResizes'

export default {
    name: "MainContentSupport",
    components: { MainContentContainer, ListItem, TechnicalJournals },
    computed: {
        support() {
            return this[GET_USER_PARAMS] && this[GET_USER_PARAMS].support
        },
        supportCid() {
            const { cid = 0 } = this.support || {}
            return +cid
        },
        supportMail() {
            const { mail = '' } = this.support || {}
            return mail
        },
        isShowCheckGroup() {
            return Boolean(this.checkCallCid)
        },
        checkCallCid() {
            return this[GET_USER_PARAMS] && this[GET_USER_PARAMS].echoContact
        },
        checkCallPhoneNumber() {
            const supportContactData = this[GET_MERGED_CONTACT_BY_ID](this.checkCallCid) // this[GET_MERGED_CONTACT_BY_ID](this.supportCid)
            let phoneField = supportContactData.fields.find(f => PHONE_CONTACT_FIELD_TYPE.includes(f.type))
            return phoneField && phoneField.value
        },
        radioServer() {
            return this[GET_USER_PARAMS] && this[GET_USER_PARAMS].radioServer
        },
        ...mapGetters(CLIENTDATA, {isElectron: GET_IS_ELECTRON}),
        ...mapGetters(CLIENTDATA, [GET_SID, GET_CLIENT_VERSION]),
        ...mapGetters(USERDATA, [GET_USER_PARAMS, GET_ROSCHAT_REDIRECTED_SERVER, GET_UID, GET_LOGIN]),
        ...mapGetters(LOGIN, [GET_SERVER_API]),
        ...mapGetters(CONTACTS, [GET_MERGED_CONTACT_BY_ID]),
        ...mapGetters(RADIO, {
            [GET_RADIO_SETTINGS]: GET_RADIO_SETTINGS,
            isTurnOn: RADIO_IS_TURN_ON,
        }),
    },
    methods: {
        doOpenChatSupport() {
            this.$emit('update:contact-selected', this.supportCid)
            this[ACT_SELECT_CONTACT](this.supportCid)
        },
        doSendMailSupport() {
            let parser = new UAParser()
            let parserResults = parser.getResult()
            let bodyClientInfoArray = []
            let url = new URL(this[GET_ROSCHAT_REDIRECTED_SERVER])
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-server')}: ${url.host + (url.port && ':' + url.port || '')}`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-server-api')}: ${this[GET_SERVER_API]}`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-login')}: ${this[GET_LOGIN]}`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-сid')}: ${this[GET_UID]}`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-sid')}: ${this[GET_SID]}`)
            bodyClientInfoArray.push(`----------------------`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-version')}: ${this[GET_CLIENT_VERSION]}`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-browser')}: ${parserResults.browser.name} ${parserResults.browser.version}`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-os')}: ${parserResults.os.name} ${parserResults.os.version}`)
            bodyClientInfoArray.push(`${this.$t('support-mail-template-body-client-cpu-arch')}: ${parserResults.cpu.architecture}`)
            bodyClientInfoArray.unshift(`----------------------`)
            bodyClientInfoArray.unshift('')
            bodyClientInfoArray.unshift(this.$t('support-mail-template-body'))
            let body = bodyClientInfoArray.join('%0D%0A')

            window.location.href = `mailto:${this.supportMail}?subject=${this.$t('support-mail-template-theme')}&body=${body}`
        },
        getLogs(last) {
            Logger.getLogs(last)
        },
        makeCall({cid, number = false}) {
            let callData = {cid, number, video: false}
            this[CALLS_CONTROLLER]({type: 'call', data: callData})
        },
        radioCall() {
            const isFullCompactMode = getIsFullCompactMode()
            if (isFullCompactMode) setSideVisible()
            const radioWord = this.$t('radio')
            const radioToolbarBtn = document.querySelector(`[title=${radioWord}]`)
            radioToolbarBtn.click()
            try {
                const channelId = SUPPORT_GROUP_CID
                if (!this.isTurnOn) this.radioStateToggle({channelId, autoTurnOn: true})
                else this[ACT_RC_RADIO_CONNECT]({channelId})
            } catch(e) {
                console.log("!! MainContentSupport.vue -> radioConnect error: ", e)
            }
        },
        ...mapActions(CONTACTS, [ACT_SELECT_CONTACT]),
        ...mapActions(INFO, [ACT_INFO_PUSH]),
        ...mapActions(PHONE_CNTL, [CALLS_CONTROLLER]),
        ...mapActions(RADIO, {
            radioStateToggle: ACT_RADIO_STATE_TOGGLE,
        }),
        ...mapActions(RC_RADIO, [ACT_RC_RADIO_CONNECT]),
    }
}
